<template>
  <div class="container">
    <div v-if="!isLogin" class="center-left">
      <div class="login-box">
        <div class="avatar">
          <img src="@/assets/avatar.jpeg" alt="头像">
        </div>
        <div class="user-desc">
          <span><a href="/login">立即登录</a></span>
          <span><a href="#">注册</a></span>
        </div>
      </div>
      <!-- 如果没有登录就显示简介详情，登录后就显示功能按钮 -->
      <div class="desc">
        <span>吃掉那只青蛙</span>
        <span>本网站域名来自《吃掉那只青蛙》，希望我们每个人都克服拖延的坏毛病。</span>
        <span>{{ currentTime }}</span>
        <span>道阻且长，行则将至</span>
        <span>待到风起时，苦赴倒悬山</span>
      </div>
    </div>
    <div v-else class="center-left">
      <div class="login-box">
        <div class="avatar">
          <img src="@/assets/avatar.jpeg" alt="头像">
        </div>
        <div class="user-desc">
          <span>{{ userid }}</span>
          <span class="logoutBtn" @click="logout">退出登录</span>
        </div>
      </div>
      <div class="menu noselect">
        <span>
          <RouterLink :to="{name: 'homehome'}">
            主页
          </RouterLink>
        </span>
        <span><a href="#">文章</a></span>
        <span>
          <RouterLink :to="{name: 'write'}">
            写作
          </RouterLink>
        </span>
        <span><a href="#">计划</a></span>
        <span><a href="#">个人中心</a></span>
      </div>
    </div>
    <RouterView/>
  </div>
</template>

<script>
import { onMounted, onUnmounted, ref, inject } from 'vue'
import request from '@/utils/request'
import getCurrentTime from '@/utils/getCurrentTime'
import Cookies from 'js-cookie'

export default {
  name: 'HomeCenter',
  setup () {
    let timer = null
    const currentTime = ref(getCurrentTime())
    const { articles, totalpage, islastpage, currentPage, categories } = inject('articleData')
    const loading = ref(true)
    const isLogin = ref(false)
    const userid = ref(undefined)
    // const doneLoading = inject('doneLoading')
    // 初始化请求文章接口
    const getAllArticle = (page) => {
      return request('/article/all', 'get', { nextpage: page }).then(
        response => {
          articles.value = response.data.articles
          totalpage.value = response.data.totalpage
          islastpage.value = response.data.islastpage
          console.log('请求结果', response.data)
        }
      ).catch(err => {
        console.log('请求出错了', err)
      })
    }

    const handleClickPage = (newPage) => {
      getAllArticle(newPage)
      currentPage.value = newPage
      // 获取实际滚动容器
      const scrollContainer = document.querySelector('.home-index')
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }

    const logout = () => {
      Cookies.remove('userid', { path: '/' })
      Cookies.remove('token', { path: '/' })
      isLogin.value = false
    }
    // 等到所有请求获取之后再展示
    onMounted(() => {
      // 获取cookie中的userid，如果存在就展示已经登录的页面，如果不存在就展示首页
      userid.value = Cookies.get('userid')
      console.log('userid', userid.value)
      if (userid.value !== undefined) {
        isLogin.value = true
      }
      timer = setInterval(() => { currentTime.value = getCurrentTime() }, 1000)
    })

    onUnmounted(() => {
      if (timer) {
        clearInterval(timer)
        timer = null
      }
    })

    return {
      getAllArticle,
      articles,
      currentTime,
      islastpage,
      totalpage,
      currentPage,
      handleClickPage,
      categories,
      loading,
      logout,
      isLogin,
      userid
    }
  }

}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  gap: 2;
  align-items: flex-start;
  .center-left {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    flex: 0 0 240px;
    position:sticky;
    top: 0;
    // background-color: rebeccapurple;
    // opacity: 30%;
    // height: 80vh;
    max-height: 100vh;

    @media (max-width: 768px) {
      display: none;
    }
    .login-box {
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      // background-color: rgb(255, 255, 255);
      padding: 50px 0;
      .login-avatar {
        margin: 0 auto;
      }
      .avatar {
        margin: 0 auto;
        border: 5px double;
        border-radius: 15px;
        height: 70px;
        width: 70px;
        img {
          height: 60px;
          width: 60px;
          object-fit: cover;
          border-radius: 10px;
        }
      }
      .user-desc {
        margin: 0 auto;
        display: flex;
        column-gap: 10px;
      }
      .logoutBtn {
        cursor: pointer;
      }
    }
    .menu {
      display: flex;
      flex-direction: column;
      gap: 40px;
      margin-top: 20px;
      span {
        text-align: center;
      }
    }
    .desc {
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      padding: 20px;
      border-radius: 15px;
      // background-color: rgb(255, 255, 255);
      span {
        // border-bottom: 1px solid rgb(155, 155, 155);
        padding-bottom: 10px;
        text-align: center;
      }
      span:last-child {
        border-bottom: 0px;
      }
    }
  }
}

</style>>
